<template>
  <div id="message">
    <div class="header flex-between">
      <div class="header-text">
        <h1>模板消息设置</h1>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="微信模板消息" name="1"></el-tab-pane>
        <el-tab-pane label="短信消息" name="2"></el-tab-pane>
      </el-tabs>
    </div>
    <div v-show="this.activeName == '1'">
      <div class="demonstration">
        <el-card class="box-card">
          <div>
            <div v-for="(item, index) in renderList" :key="index">
              <div border class="row-b">{{ item.title }}</div>
              <div
                style="
                  width: 100%;
                  display: flex;
                  flex-wrap: wrap;
                  justify-content: space-between;
                "
              >
                <div
                  class="cardItem"
                  v-for="itemui in item"
                  :key="itemui.templateID"
                >
                  <div style="width: 480px">
                    <span style="float: left">{{ itemui.msgKindtext }}</span>
                    <el-checkbox
                      style="float: right"
                      v-model="itemui.state"
                      :true-label="1"
                      :false-label="0"
                      @change="state($event, itemui.templateID)"
                      >启用</el-checkbox
                    >
                  </div>

                  <div
                    class="ss"
                    style="
                      margin-top: 20px;
                      width: 100%;
                      display: flex;
                      flex-wrap: wrap;
                      justify-content: space-between;
                      padding: 0 40px;
                    "
                  ></div>
                  <div
                    style="
                      width: 500px;
                      height: 500px;
                      border: 1px solid #707070;
                      margin-bottom: 15px;
                      padding: 15px;
                    "
                  >
                    <span style="padding: 10px; font-size: 14px"
                      >名称 :{{ itemui.msgKindtext }}
                      <p style="margin-top: 10px; font-size: 14px">
                        模板ID：{{ itemui.wxmptemplateID }}
                      </p>
                      <p style="margin-top: 29px; display: flex"></p>
                      <div class="boxstr">
                        <li>
                          {{ itemui.titleText }}
                        </li>
                      </div>
                      <el-button
                        style="
                          margin-left: 78%;
                          position: relative;
                          top: -50px;
                          background: rgba(245, 243, 224, 0.39);
                          border-radius: 5px;
                          font-size: 15px;
                          width: 100px;
                          height: 34px;
                          line-height: 9px;
                        "
                        @click="editItemContent(itemui.templateID)"
                        >修改文案</el-button
                      >

                      <p style="margin-top: 15px; display: flex"></p>
                      <div v-html="itemui.msgBody"></div>
                      <p style="margin-top: 10px; display: flex"></p>
                      <div class="myboxlist">
                        <li>
                          {{ itemui.remarkText }}
                        </li>
                      </div>

                      <el-row>
                        <el-col :span="19">
                          <p>
                            链接类型：{{
                              itemui.urlKind == 0
                                ? "链接地址"
                                : itemui.urlKind == 1
                                ? "授权小程序"
                                : itemui.urlKind == 2
                                ? "未授权小程序"
                                : ""
                            }}
                          </p>
                          <p>
                            小程序名称：{{
                              itemui.urlKind == 0
                                ? ""
                                : itemui.urlKind == 1
                                ? itemui.appName
                                : itemui.urlKind == 2
                                ? itemui.appID
                                : ""
                            }}
                          </p>
                          <p>详情跳转：{{ itemui.pageUrl }}</p>
                        </el-col>
                        <el-col :span="5">
                          <el-button
                            style="
                              margin-left: -10%;
                              background: rgba(245, 243, 224, 0.39);
                              border-radius: 5px;
                              font-size: 15px;
                              width: 100px;
                              height: 36px;
                              line-height: 9px;
                            "
                            @click="addressClick(itemui.templateID)"
                            >修改地址</el-button
                          >
                        </el-col>
                      </el-row>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </div>
      <!-- </div> -->
    </div>

    <!-- 短信消息模块 -->
    <div v-show="this.activeName == '2'">
      <div v-for="(item, i) in Inquire" :key="i">
        <div border class="row-b">{{ item.title }}</div>
        <div class="demonstration" v-for="(baritem, i) in item.arr" :key="i">
          <el-card class="box-card">
            <div>
              <span
                style="
                  font-size: 14px;
                  font-family: Source Han Sans CN;
                  color: #000000;
                "
                >{{ baritem.msgKindtext }}</span
              >
              <span style="margin-left: 280px">
                <el-checkbox
                  v-model="baritem.state"
                  :true-label="0"
                  :false-label="1"
                  @change="Smastatus($event, baritem.templateID)"
                  >启用</el-checkbox
                >
                <div class="ss">
                  <div
                    style="
                      display: flex;
                      width: 500px;
                      height: 280px;
                      border: 1px solid #707070;
                      margin-top: 18px;
                    "
                  >
                    <span
                      style="padding: 15px; font-size: 14px; margin-top: 18px"
                    >
                      【{{brand}}】
                      <p style="margin-top: 20px; display: flex">
                        短信主要内容
                        <el-input
                          type="textarea"
                          :disabled="true"
                          :rows="6"
                          style="width: 240px; height: 60px; margin-left: 10px"
                          v-model="baritem.msgBody"
                        >
                        </el-input>
                        <el-button
                          style="
                            margin-left: 30px;
                            background: rgba(245, 243, 224, 0.39);
                            border-radius: 5px;
                            font-size: 15px;
                            width: 100px;
                            height: 36px;
                            line-height: 9px;
                          "
                          @click="curatuanDer(baritem.templateID)"
                        >
                          修改文案</el-button
                        >
                      </p>
                      <p style="margin-top: 100px">退订回T</p>
                    </span>
                  </div>
                </div>
              </span>
            </div>
          </el-card>
        </div>
      </div>
    </div>
    <!-- 修改地址弹窗口 -->
    <div class="amend">
      <el-dialog
        width="25%"
        title="修改地址"
        :visible.sync="addressVisible"
        :closeOnClickModal="false"
      >
        <el-form label-width="80px">
          <el-form status-icon label-width="100px" class="demo-ruleForm">
            <!-- <el-form-item label="链接地址"
                          prop="pass">
              <input type="text"
                     style="height: 30px"
                     v-model="curItem.pageUrl"
                     :disabled="true" />
            </el-form-item> -->
            <el-form-item label="链接类型">
              <!-- <el-radio-group v-model="curItem.urlKind">
                <el-radio :label="0">备选项</el-radio>
                <el-radio :label="1">备选项</el-radio>
                <el-radio :label="2">备选项</el-radio>
              </el-radio-group> -->
              <el-radio :label="0" v-model="curItem.urlKind">链接地址</el-radio>
              <div style="padding-left: 20px">
                链接地址
                <input
                  type="text"
                  v-model="curItem.pageUrl1"
                  :disabled="curItem.urlKind != 0"
                  style="height: 30px"
                />
              </div>
              <el-radio :label="1" v-model="curItem.urlKind"
                >授权小程序</el-radio
              >
              <div style="padding-left: 20px">
                <el-select
                  v-model="curItem.appID"
                  :disabled="curItem.urlKind != 1"
                  placeholder=""
                  style="height: 30px"
                >
                  <el-option
                    v-for="item in curAercx"
                    :label="item.appdesc"
                    :value="item.appid"
                    :key="item.appid"
                  ></el-option>
                </el-select>
              </div>
              <div style="padding-left: 20px; padding-top: 6px">
                页面路径
                <input
                  :disabled="curItem.urlKind != 1"
                  type="text"
                  v-model="curItem.pageUrl2"
                  style="height: 30px"
                />
              </div>
              <el-radio :label="2" v-model="curItem.urlKind"
                >未授权小程序</el-radio
              >
              <div style="padding-left: 20px">
                APP ID
                <input
                  type="text"
                  style="height: 30px"
                  :disabled="curItem.urlKind != 2"
                  v-model="curItem.appID"
                />
              </div>
              <div style="padding-left: 20px">
                页面路径
                <input
                  :disabled="curItem.urlKind != 2"
                  type="text"
                  v-model="curItem.pageUrl3"
                  style="height: 30px"
                />
              </div>
            </el-form-item>
          </el-form>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="ddressonSubmit()">确 定</el-button>
          <el-button @click="btnCanbox">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 修改文案弹窗口 -->
    <div class="amend">
      <el-dialog
        width="30%"
        title="编辑模板信息"
        :visible.sync="amendVisible"
        :closeOnClickModal="false"
      >
        <el-form label-width="80px">
          <el-form
            status-icon
            label-width="100px"
            class="demo-ruleForm"
            ref="addUserFormRef"
          >
            <el-form-item label="模板名称" prop="pass">
              <input
                type="text"
                :disabled="true"
                style="
                  height: 30px;
                  width: 160px;
                  border: 1px solid #707070;
                  padding-left: 5px;
                "
                v-model="curItem.msgKindtext"
              />
            </el-form-item>
            <el-form-item label="模板头部信息">
              <el-input
                style="
                  width: 90%;
                  background: rgba(255, 255, 255, 0.39);
                  border: 1px solid #707070;
                "
                type="textarea"
                :rows="5"
                placeholder=""
                v-model="curItem.titleText"
              >
              </el-input>
              <p class="tarbar">
                可用变量：[会员姓名]、[会员昵称]、[卡号]、[会员等级]、[积分]、[券库名称]、[待过期积分]，复制使用时请包含[]。
              </p>
            </el-form-item>
            <el-form-item label="模板尾部信息">
              <el-input
                style="
                  width: 90%;
                  background: rgba(255, 255, 255, 0.39);
                  border: 1px solid #707070;
                "
                type="textarea"
                :rows="5"
                v-model="curItem.remarkText"
              >
              </el-input>
              <p class="tarbar">
                可用变量：[会员姓名]、[会员昵称]、[卡号]、[会员等级]、[积分]、[券库名称]、[待过期积分]，复制使用时请包含[]。
              </p>
            </el-form-item>
            <el-form-item>
              <el-button class="dialog-footer" @click="onSubmit()"
                >确 定</el-button
              >
              <el-button @click="btnCanl()">取 消</el-button>
            </el-form-item>
          </el-form>
        </el-form>
      </el-dialog>
    </div>
    <!-- 短信修改文案弹窗 -->
    <div class="amend">
      <el-dialog
        width="25%"
        title="编辑模板信息"
        :visible.sync="DuanxVisible"
        :closeOnClickModal="false"
      >
        <el-form label-width="100px">
          <el-form-item label="短信文案信息">
            <el-input
              type="textarea"
              :rows="5"
              style="width: 85%; margin-left: 5px; border: 1px solid black"
              v-model="curItem.msgBody"
            >
            </el-input>
            <p class="tarbar">
              可用变量：[会员姓名]、[会员昵称]、[卡号]、[会员等级]、[积分]、[券库名称]、[待过期积分]，复制使用是请包含[]
            </p>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="Smsbtn">确 定</el-button>
          <el-button @click="btnCanel">取 消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
//接口数据引入
import {
  getRoleDetail,
  postRoleDetail,
  Demandquery,
  getDemandquery,
  postqueryList,
  Shutdownenable,
  Setruresy,
  Smastatus,
} from "@/api/mubanmation";
export default {
  data() {
    return {
      activeName: "1",
      DuanxVisible: false,
      amendVisible: false,
      addressVisible: false,
      //数据变量
      list: [], //存储微信所有的数据
      Inquire: {}, //存储短信数据
      renderList: [], //微信标题
      duanxList: [],
      curItem: {}, //
      curItemold: {},
      setddress: "0", //修改地址单选
      curAercx: [], //小程序下拉框存放消息
      // backList: ' 会员姓名： keyword1.DATA \n 绑定手机号：keyword2.DATA ',
      //微信消息类型：
      MsgKindList: [
        {
          code: 10,
          text: "用户注册成功",
        },
        {
          code: 11,
          text: "会员等级升级提醒",
        },
        {
          code: 12,
          text: "会员等级降级提醒",
        },
        {
          code: 20,
          text: "发券时提醒",
        },
        {
          code: 21,
          text: "券核销提醒",
        },
        {
          code: 22,
          text: "券即将过期提醒",
        },
        {
          code: 30,
          text: "积分变动提醒",
        },
        {
          code: 31,
          text: "积分即将过期提醒",
        },
        {
          code: 32,
          text: "积分兑换提醒",
        },
        {
          code: 40,
          text: "销售提醒",
        },
        {
          code: 50,
          text: "礼品邮寄发货提醒",
        },
        {
          code: 51,
          text: "礼品到店领取核销成功通知",
        },
      ],
      // 短信消息类型
      statusText: [
        {
          code: 1,
          text: "验证码模板",
        },
        {
          code: 2,
          text: "GIADA Friends审核通过短信模板",
        },
        {
          code: 3,
          text: "GIADA Friends信息不全审核不通过短信模板",
        },
        {
          code: 4,
          text: "GIADA Friends暂不符合资格审核不通过短信模板",
        },
        {
          code: 5,
          text: "券发放提醒",
        },
        {
          code: 6,
          text: "券核销提醒",
        },
        {
          code: 7,
          text: "券到期提醒",
        },
        {
          code: 8,
          text: "礼品领用的短信模板",
        },
      ],
      cuarList: [],
      //appid传参
      appidcard: "",
    };
  },
  created() {
    this.XiugaiCopy();
    this.Demandquery();
  },
  computed: {
    brand() {
      return localStorage.getItem('cpyName') || 'GIADA';
    }
  },
  methods: {
    //微信点击修改文案
    editItemContent(tempId) {
      this.amendVisible = true;
      //从list遍历当前点击的item
      let res = this.list.filter((e) => {
        if (tempId === e.templateID) return e;
      });
      this.curItem = res[0];
    },
    async postqueryList() {
      const res = await postqueryList();
      this.curAercx = res.data;
    },
    //微信点击修改地址
    addressClick(tempId) {
      console.log(tempId);
      this.postqueryList();
      this.setddress = 0;
      this.addressVisible = true;
      //从list遍历当前点击的item
      let res = this.list.filter((e) => {
        if (tempId === e.templateID) return e;
      });
      // this.curItem = res[0];
      //  res.forEach((item) => {
      //   this.curItem.pageUrl1 = item.urlKind == 0 ? item.pageUrl : "";
      //   this.curItem.pageUrl2 = item.urlKind == 1 ? item.pageUrl : "";
      //   this.curItem.pageUrl3 = item.urlKind == 2 ? item.pageUrl : "";
      // })
      this.curItem = res[0];
      if (this.curItem.urlKind == 0) {
        this.curItem.pageUrl1 = this.curItem.pageUrl;
      } else if (this.curItem.urlKind == 1) {
        this.curItem.pageUrl2 = this.curItem.pageUrl;
      } else if (this.curItem.urlKind == 2) {
        this.curItem.pageUrl3 = this.curItem.pageUrl;
      } else {
        this.pageUrl1 = "";
        this.pageUrl2 = "";
        this.pageUrl3 = "";
      }
      console.log("123123", this.curItem);
      this.setddress = localStorage.getItem("curbar", this.setddress);
    },
    //短信点击修改文案
    curatuanDer(tempId) {
      this.DuanxVisible = true;
      //从list遍历当前点击的item
      this.Inquire.filter((e) => {
        for (let i = 0; i < e.arr.length; i++) {
          const item = e.arr[i];
          if (tempId === item.templateID) {
            this.curItem = item;
          }
        }
      });
    },
    //短信数据请求初始化
    async Demandquery() {
      const res = await Demandquery();
      this.Inquire = [];
      let Duanxtitle = [
        "验证码",
        "优惠券提醒",
        "GIADA Friends相关短信提醒",
        "销售相关短信提醒",
      ];
      for (let i = 0; i < res.data.length; i++) {
        this.Inquire.push({});
        this.Inquire[i].title = Duanxtitle[i];
        this.Inquire[i].arr = res.data[i];
      }
      if (this.Inquire[0].arr) {
        for (let i = 0; i < this.Inquire.length; i++) {
          const item = this.Inquire[i];
          for (let j = 0; j < item.arr.length; j++) {
            let item1 = item.arr[j];
            for (let x = 0; x < this.statusText.length; x++) {
              const item2 = this.statusText[x];
              if (item1.templateKind === item2.code) {
                item1.msgKindtext = item2.text;
              }
            }
          }
          // this.duanxList = newCur;
          // console.log("短信初始化数据", this.duanxList);
        }
      }
    },
    //微信模板信息请求初始化
    async XiugaiCopy() {
      let newApp = await getRoleDetail();
      newApp.data.forEach((item) => {
        item.msgBody = item.msgBody.replace(/\n/g, "<br/>");
      });
      this.list = newApp.data;
      let newArr = [];
      let titleList = ["等级变动提醒", "优惠券提醒", "积分提醒", "销售提醒"];
      for (let i = 0; i < this.list.length; i++) {
        let item = this.list[i];
        for (let i = 0; i < this.MsgKindList.length; i++) {
          const MsgKind = this.MsgKindList[i];
          if (MsgKind.code == item.msgKind) {
            item.msgKindtext = MsgKind.text;
          }
        }
      }
      for (let i = 0; i < this.list.length; i += 3) {
        newArr.push(this.list.slice(i, i + 3));
      }
      for (let i = 0; i < titleList.length; i++) {
        newArr[i].title = titleList[i];
      }
      this.renderList = newArr;
      console.log("------", this.renderList);
      let arr = [];
      this.list.forEach((item) => {
        arr = item.msgBody.split("\n");
        arr.splice(0, 1);
        arr.pop();
        this.cuarList.push(arr);
      });
      // console.log(this.cuarList);
      // console.log(this.list);
    },
    //修改文案确定按钮
    async onSubmit() {
      let { remarkText, templateID, titleText } = this.curItem;
      await postRoleDetail({ remarkText, templateID, titleText });
      this.amendVisible = false;
      this.$message({
        message: "修改成功",
        type: "success",
      });
      this.XiugaiCopy();
    },
    //修改地址确定按钮
    async ddressonSubmit() {
      this.addressVisible = false;
      // let { urlKind, appID, pageUrl, templateID } = this.curItem;
      // let pageUrl =
      //   this.curItem.urlKind == 0
      //     ? this.curItem.pageUrl1
      //     : this.curItem.urlKind == 1
      //     ? this.curItem.pageUrl2
      //     : this.curItem.urlKind == 2
      //     ? this.curItem.pageUrl3
      //     : "";
      // console.log(this.curItem.pageUrl2);
      let data = {
        urlKind: this.curItem.urlKind,
        appID: this.curItem.appID,
        pageUrl:
          this.curItem.urlKind == 0
            ? this.curItem.pageUrl1
            : this.curItem.urlKind == 1
            ? this.curItem.pageUrl2
            : this.curItem.urlKind == 2
            ? this.curItem.pageUrl3
            : "",
        templateID: this.curItem.templateID,
      };
      await postRoleDetail(data);
      // localStorage.setItem("curbar", this.setddress);
      this.$message({
        message: "修改成功",
        type: "success",
      });
      this.XiugaiCopy();
    },
    //短信弹框确定按钮
    async Smsbtn() {
      let { msgBody, templateID } = this.curItem;

      getDemandquery({ msgBody, templateID });

      this.DuanxVisible = false;
      this.$message({
        message: "修改成功",
        type: "success",
      });
      this.Demandquery();
      // debugger
    },

    //点击短信修改文案
    // modifydoCument (plateId) {
    //   console.log(plateId);
    //   // debugger
    // },
    //微信状态
    state(e, id) {
      // console.log(e);
      let data = { templateID: id };
      if (e) {
        Shutdownenable(data);

        this.$message.success("启用模板成功");
      } else {
        Setruresy(data);

        this.$message("关闭模板使用");
      }
    },
    //短信状态
    Smastatus(e, id) {
      // console.log(e);
      // console.log(id);
      // debugger
      let data = { templateID: id, state: e };
      if (e) {
        Smastatus(data);
        this.$message("关闭模板使用");
      } else {
        Smastatus(data);
        this.$message.success("启用模板成功");

      }
      this.$forceUpdate();
    },
    //取消时重置内容
    btnCanl() {
      this.XiugaiCopy();
      this.amendVisible = false;
    },
    btnCanel() {
      this.Demandquery();
      this.DuanxVisible = false;
    },
    btnCanbox() {
      this.XiugaiCopy();
      this.addressVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
#message {
  height: 100%;
}
.header {
  .header-text {
    height: 50px;
    margin-top: 20px;
    color: #76734f;
  }
}
.boxssh {
  position: relative;
  left: -60%;
  font-size: 22px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  line-height: 37px;
  color: #a19b5a;
}
.boxssh span {
  margin-left: 33px;
}
.row-b {
  height: 39px;
  background: rgba(227, 227, 227, 0.39);
  padding-top: 8px;
  opacity: 1;
}
.demonstration {
  width: 100%;
}
::v-deep {
  .amend {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }

    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2;
    }
    .el-textarea__inner:hover {
      border: #fff;
    }
    .el-textarea__inner {
      border: #fff;
    }
  }
}

.el-textarea__inner {
  resize: none !important;
}
.flex-between {
  margin-right: 60%;
}
#tab-1,
#tab-2 {
  font-size: 22px;
}
.is-active {
  color: #6c6937 !important;
}
.tarbar {
  font-size: 14px;
  color: #808080;
  letter-spacing: 1px;
  line-height: 22px;
}
.ValidateForm {
  display: flex;
}
.cardItem {
  margin-top: 0px;
  display: flex;
  flex-direction: column;
  padding: 1.25rem 0.625rem;
  /* border: 0.0625rem solid #707070; */
  border-bottom: none;
}
.cardItem:last-child {
  // border-bottom: 1px solid #707070;
  margin-bottom: 20px;
}
.boxstr {
  width: 75%;
  height: 60px;
  word-wrap: break-word;
  margin-left: -10px;
  margin-top: -20px;
  overflow-y: hidden;
  li {
    list-style: none;
    padding-left: 8px;
    line-height: 20px;
  }
}
.myboxlist {
  width: 360px;
  height: 70px;
  word-wrap: break-word;
  overflow-y: hidden;
  margin-left: -10px;
  li {
    margin-top: 10px;
    list-style: none;
    padding-left: 8px;
    line-height: 20px;
  }
}
</style>